<template>
  <v-select class="w-full" 
    v-model="municipio" 
    :options="municipios" 
    label="nombre"
    @input="$emit('input', municipio)"
    :disabled="disabled"
    :reduce="id => `/api/val_municipios/${id.id}`" 
  />
</template>

<script>
import vSelect from 'vue-select'
import commonComponentsStore from '@/store/common-components/index.js'

export default {
  components: {
    'v-select': vSelect
  },
  props: {
    municipioSelected: String,
    provincia: Number,
    disabled: Boolean
  },
  data () {
    return {
      municipio: (this.municipioSelected !== null && this.municipioSelected !== undefined) ? JSON.parse(JSON.stringify(this.municipioSelected)) : null,
      municipios: []
    }
  },
  watch: {
    municipioSelected () {
      this.municipio = this.municipioSelected
    }
  },
  async created () {
    if (!commonComponentsStore.isRegistered) {
      this.$store.registerModule('commonComponentsStore', commonComponentsStore)
      commonComponentsStore.isRegistered = true
    }
    this.municipios = this.$store.state.commonComponentsStore.municipios
  }
}
</script>

<style>

</style>